import API_URL from './config';

export const logActivity = async (moduleName, action, entityId = null, details = null) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) return;
        
        await fetch(`${API_URL}/logs`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                module: moduleName,
                action,
                entity_id: entityId ? String(entityId) : null,
                details: details ? (typeof details === 'string' ? details : JSON.stringify(details)) : null,
                source: 'Interface'
            })
        });
    } catch (err) {
        console.error('Failed to log activity', err);
    }
};
